import React, { useEffect, useState, createElement } from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { WhatInsideSection } from '../components/WhatInsideSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { PriceSection } from '../components/PriceSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { LegalModal } from '../components/LegalModal';
export function SalesPage() {
  const [legalModal, setLegalModal] = useState<'terms' | 'privacy' | null>(null);
  // --- SEO & social share meta tags ---
  useEffect(() => {
    document.title = 'Escape 9-a-5 | El Método para Mujeres Latinas que Quieren Libertad Financiera';
    const setMeta = (property: string, content: string, isName = false) => {
      const attr = isName ? 'name' : 'property';
      let el = document.querySelector(`meta[${attr}="${property}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, property);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };
    setMeta('og:title', 'Escape 9-a-5 — El Método que Está Revolucionando Estados Unidos');
    setMeta('og:description', 'El método exclusivo para mujeres latinas que quieren libertad financiera desde casa. Sin jefes. Sin horarios. Solo $6.36.');
    setMeta('og:type', 'website');
    setMeta('twitter:card', 'summary_large_image', true);
    setMeta('twitter:title', 'Escape 9-a-5 — El Método para Mujeres Latinas', true);
    setMeta('twitter:description', 'Libertad financiera desde casa. Sin jefes. Sin horarios. Solo $6.36.', true);
    setMeta('description', 'El método exclusivo para mujeres latinas que quieren libertad financiera desde casa. Sin jefes. Sin horarios. Solo $6.36.', true);
  }, []);
  // --- Meta Pixel ---
  useEffect(() => {
    if ((window as any).fbq) {
      ;
      (window as any).fbq('track', 'PageView');
      return;
    }
    const fbq: any = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    (window as any).fbq = fbq;
    if (!(window as any)._fbq) (window as any)._fbq = fbq;
    fbq('init', '672436842593118');
    fbq('track', 'PageView');
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    const noscript = document.createElement('noscript');
    noscript.innerHTML = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=672436842593118&ev=PageView&noscript=1" />`;
    document.head.appendChild(noscript);
  }, []);
  return <>
      <LegalModal type={legalModal} onClose={() => setLegalModal(null)} data-id="element-347" />

      <main className="min-h-screen w-full font-sans text-brand-dark bg-brand-light selection:bg-brand-secondary selection:text-white" data-id="element-348">
        <UrgencyBar data-id="element-349" />
        <HeroSection data-id="element-350" />
        <ProblemSection data-id="element-351" />
        <SolutionSection data-id="element-352" />
        <ForWhoSection data-id="element-353" />
        <WhatInsideSection data-id="element-354" />
        <TestimonialsSection data-id="element-355" />
        <PriceSection data-id="element-356" />
        <GuaranteeSection data-id="element-357" />
        <FAQSection data-id="element-358" />
        <CTASection data-id="element-359" />

        <footer className="bg-[#11050a] text-rose-300/40 py-12 text-center border-t border-rose-900/20" data-id="element-360">
          <div className="max-w-3xl mx-auto px-4 space-y-6" data-id="element-361">
            {/* Brand */}
            <p className="font-heading italic text-xl text-rose-300/70" data-id="element-362">
              Escape 9-a-5
            </p>

            {/* Disclaimer */}
            <div className="bg-white/5 border border-rose-900/20 rounded-2xl px-6 py-4 text-xs text-rose-300/50 leading-relaxed max-w-2xl mx-auto" data-id="element-363">
              <span className="font-bold text-rose-300/70 uppercase tracking-wider text-xs" data-id="element-364">
                Aviso Legal:{' '}
              </span>
              Los resultados mostrados son ejemplos reales pero no típicos. Los
              ingresos varían según el esfuerzo y dedicación de cada persona.
              Este producto es material educativo y no garantiza ganancias
              específicas. No somos responsables de decisiones financieras
              basadas en este contenido.
            </div>

            {/* Legal Links */}
            <div className="flex items-center justify-center gap-6 text-xs" data-id="element-365">
              <button onClick={() => setLegalModal('terms')} className="text-rose-300/50 hover:text-brand-secondary underline underline-offset-2 transition-colors" data-id="element-366">
                Términos y Condiciones
              </button>
              <span className="text-rose-900/60" data-id="element-367">·</span>
              <button onClick={() => setLegalModal('privacy')} className="text-rose-300/50 hover:text-brand-secondary underline underline-offset-2 transition-colors" data-id="element-368">
                Política de Privacidad
              </button>
            </div>

            {/* Copyright + Facebook disclaimer */}
            <div className="text-xs text-rose-300/30 space-y-2" data-id="element-369">
              <p data-id="element-370">
                © {new Date().getFullYear()} Escape 9-a-5 · Todos los derechos
                reservados.
              </p>
            </div>
          </div>
        </footer>
      </main>
    </>;
}